export const dateSplitter = (date: Date = new Date()) => {
  const pad = (n: number) => n.toString().padStart(2, "0");
  const yyyy = date.getFullYear();
  const mm = pad(date.getMonth() + 1);
  const dd = pad(date.getDate());
  const formatted = `${yyyy}-${mm}-${dd}`;



  return formatted;
};
